import { getCoverType, getQuoteForm, getSelectedChildCoverOption } from '../../../selectors/personalAccident/quote';
import { getPersonalDetailsForm } from '../../../selectors/personalAccident/personalDetails';
import { getSpouseDetailsForm } from '../../../selectors/personalAccident/spouseDetails';
import { getChildDetailsForms } from '../../../selectors/personalAccident/childDetails';
import { getIsApiPending } from '../../../selectors/personalAccident/personalDetails';
import { apiTransitionPersonalDetailsForm } from '../../../actions/personalAccident/personalDetails';
import { getAgentForm } from '../../../selectors/ugMotorInsurance/travelAgentModal';
import { getAccessToken } from '../../../selectors/personalAccident/payments';
import { getPremiumCalculation } from '../../../selectors/personalAccident/quote';
import axios from 'axios';
import { setCustomerIdValue } from '../../../actions/personalAccident/personalDetails';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const livesCoveredSubmitService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPersonalDetailsForm.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(setCustomerIdValue(resp.data.data.insurance.id));
                    store.dispatch(apiTransitionPersonalDetailsForm.success());
                }
            } catch (e) {
                console.error(e);

                store.dispatch(apiTransitionPersonalDetailsForm.failure());
            }
        }
    })();
    return next(action);
};

const createDependants = ({ childrenIncluded, childDetails }) => {
    const dependants = [];

    if (childrenIncluded) {
        for (child in childDetails.forms) {
            dependants.push({
                fullName:
                    child.firstName?.value && child.lastName?.value
                        ? `${child.firstName?.value} ${child.lastName?.value}`
                        : 'N/A',
                gender: 'N/A',
                relationship: 'Child',
                dateOfBirth: `${child.dob?.value}` || 'N/A',
                profession: 'N/A',
                lastExpenseSplit: 10,
            });
        }
    }

    return dependants;
};

const payloadCollection = (state) => {
    const quotation = getQuoteForm(state);
    const personalDetails = getPersonalDetailsForm(state);
    const spouseDetails = getSpouseDetailsForm(state);
    const childDetails = getChildDetailsForms(state);

    const coverType = getCoverType(state);
    const premiumCalculation = getPremiumCalculation(state);
    const childCoverPremium = getSelectedChildCoverOption(state);

    const dependants = createDependants({
        childrenIncluded: quotation.childrenIncluded?.value === 'yes',
        childDetails,
    });

    const payload = {
        countryCode: gatsbyStack.toUpperCase(),
        coverType,
        fullName: `${personalDetails.firstName.value} ${personalDetails.lastName.value}`,
        dateOfBirth: quotation.dob.value,
        idNumber: personalDetails.idNumber.value,
        gender: 'N/A',
        maritalStatus: quotation.spouseIncluded?.value === 'yes' ? 'MARRIED' : 'SINGLE',
        numberOfChildren: childDetails.length,
        spouseIncluded: quotation.spouseIncluded.value == 'yes',
        spouseFullName:
            quotation.spouseIncluded.value == 'yes'
                ? `${spouseDetails.firstName?.value} ${spouseDetails.lastName?.value}`
                : 'N/A',
        spouseDateOfBirth:
            quotation.spouseIncluded?.value == 'yes' && quotation.spouseIncluded.value == 'yes'
                ? spouseDetails.dob?.value
                : 'N/A',
        spouseTaxPinNumber:
            quotation.spouseIncluded?.value == 'yes' && spouseDetails.tinNumber?.value
                ? spouseDetails.tinNumber?.value
                : 'N/A',
        spouseIdNumber:
            quotation.spouseIncluded?.value == 'yes' && spouseDetails.idNumber?.value
                ? spouseDetails.idNumber?.value
                : 'N/A',
        spousePhoneNumber:
            quotation.spouseIncluded?.value == 'yes' && spouseDetails.phoneNumber?.value
                ? spouseDetails.phoneNumber?.value
                : 'N/A',
        spouseStreetAddress:
            quotation.spouseIncluded?.value == 'yes' && spouseDetails.streetAddress?.value
                ? spouseDetails.streetAddress?.value
                : 'N/A',
        spouseSuburb:
            quotation.spouseIncluded?.value == 'yes' && spouseDetails.suburb?.value
                ? spouseDetails.suburb?.value
                : 'N/A',
        spouseCity:
            quotation.spouseIncluded?.value == 'yes' && spouseDetails.city?.value ? spouseDetails.city?.value : 'N/A',
        taxPinNumber: personalDetails.tinNumber.value,
        nhifNumber: 'N/A',
        profession: quotation.profession?.value || 'N/A',
        nationality: 'Kenyan',
        phoneNumber: personalDetails.phoneNumber.value || 'N/A',
        emailAddress: personalDetails.email?.value || 'N/A',
        city: personalDetails.city.value ? personalDetails.city.value : 'N/A',
        suburb: personalDetails.suburb.value ? personalDetails.suburb.value : 'N/A',
        streetAddress: personalDetails.streetAddress.value ? personalDetails.streetAddress.value : 'N/A',
        country: 'Kenya',
        coverLimit: parseInt(quotation.coverLimit.value),
        annualPremium: premiumCalculation?.value ? premiumCalculation?.value : 0,
        childCoverPremium: childCoverPremium.value?.cover_premium ? childCoverPremium.value.cover_premium : 0,
        planId: 1,
        dependants,
    };

    //agent details
    const agent = getAgentForm(state);
    const agentPayload = {
        agentCode: agent.agentCode?.value || 'N/A',
        agentName: agent.name?.value || 'N/A',
        referredByAgent: agent.name?.value ? true : false,
    };

    return {
        ...payload,
        ...agentPayload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/personal-accident/lives-covered';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
